module.exports = __webpack_public_path__ + "static/media/icon_3.8d6103a4.png";